export var Name = 'clear-basket';
export var ClearBasketEvent = Name;